import { Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import {
  CardWithoutCostFragment,
  MinimalCardPreviewFragment,
  MinimalDigitalCardFragment,
} from 'src/graphql/generated/graphql'
import styles from './digitalCardHistoryCell.module.scss'
import { Button } from 'src/design_system/components/Button/Button'
import { useDeviceInfo, useState } from 'src/hooks'
import { LEGACY_SITE_URL } from 'src/app/api'
import { useMarketingContent } from 'src/react_query'
import { getCreateActSharePayload } from 'src/utils/getCreateActSharePayload'

interface DigitalCardHistoryCellProps {
  digitalCard: MinimalDigitalCardFragment
  onViewCard: (card: MinimalCardPreviewFragment) => void
}

const baseURL = LEGACY_SITE_URL

const DigitalCardHistoryCell: React.FunctionComponent<
  DigitalCardHistoryCellProps
> = props => {
  const deviceInfo = useDeviceInfo()
  const { data: marketingContent } = useMarketingContent()
  const { digitalCard, onViewCard } = props
  const [copyBtTitle, setCopyBtTitle] = useState('Copy Link')

  const createdAtDateFormatted = new Date(digitalCard.createdAt)

  const defaultActShareMessage =
    marketingContent?.defaultActShareMessage.content ?? ''

  const token = digitalCard.recipients[0].token
  const link = `${baseURL}/act/${token}`

  const shareData = getCreateActSharePayload(
    deviceInfo.os,
    link,
    defaultActShareMessage,
  )

  return (
    <div className={styles.digitalCardHistoryRowWrapper}>
      <div className={styles.dchPreviewAndDetailsWrapper}>
        <div
          className={styles.dchFrontImage}
          style={{
            backgroundImage: `url("${digitalCard.card.frontPreviewUrl}")`,
            cursor: 'pointer',
          }}
          onClick={() =>
            onViewCard(digitalCard.card as unknown as CardWithoutCostFragment)
          }
        />
        <div>
          <div className={styles.dchTitle}>
            <Text type="body" weight="bold">
              {digitalCard.shareMessageTitle}
            </Text>
          </div>
          <div className={styles.dchCreatedOn}>
            <Text
              type="footnote"
              isItalic={true}
              weight="thin"
              outset={{ right: 'x1' }}
            >
              Created On:
            </Text>
            <Text type="caption">
              {createdAtDateFormatted.toLocaleDateString('en-US')}
            </Text>
          </div>
          <div className={styles.dchContact}>
            <Text
              type="footnote"
              isItalic={true}
              weight="thin"
              outset={{ right: 'x1' }}
            >
              Sent to:
            </Text>
            <Text type="caption">
              {`${digitalCard.recipients[0].contactRequest?.contact?.firstName ?? digitalCard.recipients[0].contactRequest?.firstName ?? ''} ${digitalCard.recipients[0].contactRequest?.contact?.lastName ?? digitalCard.recipients[0].contactRequest?.lastName ?? ''}`}
            </Text>
          </div>
        </div>
      </div>
      <div className={styles.dchShareLink}>
        <Button
          title={copyBtTitle}
          width="100%"
          whiteSpace="nowrap"
          background="#000"
          textColor="#fff"
          onClick={async () => {
            await navigator.clipboard.writeText(
              `${defaultActShareMessage}\n${link}`,
            )
            setCopyBtTitle('Link Copied')
          }}
        />
        {typeof navigator !== 'undefined' &&
          typeof navigator.canShare === 'function' &&
          navigator.canShare?.(shareData) && (
            <Button
              title={'Share'}
              width="100%"
              onClick={async () => {
                if (navigator?.share && navigator.canShare(shareData)) {
                  try {
                    await navigator.share(shareData)
                  } catch (err) {
                    console.error(err)
                  }
                }
              }}
            />
          )}
      </div>
    </div>
  )
}

export default DigitalCardHistoryCell
